export enum MenuModulesEnum {
    invoiceAndDocuments = 'INVOICE_AND_DOCUMENTS',
    notifications = 'NOTIFICATIONS',
    bookingSummary = 'BOOKING_SUMMARY',
    soa = 'STATEMENT_OF_ACCOUNTS',
    admin = 'ADMIN',
    schedule = 'SCHEDULE',
    si = 'SI',
    shipmentTracking = 'SHIPMENT_TRACKING'
}
